/* eslint-disable @next/next/no-img-element */
import cn from 'classnames'
import { ElementType, HTMLAttributes, memo, useMemo } from 'react'

import styles from './Avatar.module.scss'
import { formatAlt } from './utils'

import { DEFAULT_PROFILE_PIC } from '~lib/constants'

export interface AvatarBaseProps {
  as?: ElementType
  alt?: string
  color?: string
  className?: string
  label?: string
  src?: string
  placeholderSrc?: string
  shouldDisplayAlt?: boolean
  outlined?: boolean
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
  variant?: 'accent' | 'secondary'
}

export type AvatarProps = Prefer<AvatarBaseProps, HTMLAttributes<HTMLElement>>

function Avatar({
  as: Element = 'span',
  alt,
  color,
  className,
  outlined,
  shouldDisplayAlt,
  src,
  size = 'md',
  variant = 'secondary',
  ...props
}: AvatarProps) {
  const style = useMemo(
    () => ({
      backgroundColor: color,
    }),
    [color]
  )

  return (
    <Element className={cn(styles.root, styles[variant], outlined && styles.outlined, className)} {...props}>
      <span style={style} className={cn(styles.inner, styles[size])}>
        {src || !shouldDisplayAlt ? (
          <img className={styles.image} alt={alt} src={src || DEFAULT_PROFILE_PIC} />
        ) : (
          <span title={alt} className={styles.text}>
            {alt && formatAlt(alt)}
          </span>
        )}
      </span>
    </Element>
  )
}

export default memo(Avatar)
